var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editor',{ref:"editor",attrs:{"placeholder":_vm.placeholder,"upload-image":_vm.uploadImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }